import { Grid, Button, ActionArea, Card } from '@design-systems/canvas-ui'
import Icon, {
  TimeHistoryIcon,
  ArrowUpLeftIcon,
  CloseIcon,
} from '@design-systems/react-icons'
import type { ReactNode } from 'react'
import type { RecentSearch } from '../../../../graphql/queries/globalSearch/recentSearchesQueries'
import styles from './RecentSearches.module.css'

type RecentSearchesProps = {
  setIndex: (index: number) => void
  searchIndex: number
  getBoldText: (searchText: string) => ReactNode
  setSearchTerm: (searchTerm: string) => void
  setInputFocus: (focus: boolean) => void
  recentSearches: RecentSearch[]
  handleSelectRecentSearch: (searchText: string) => void
  handleDeleteRecentSearch: (id: string) => void | Promise<void>
}

export const RecentSearches = ({
  setIndex,
  searchIndex,
  getBoldText,
  setSearchTerm,
  setInputFocus,
  recentSearches,
  handleSelectRecentSearch,
  handleDeleteRecentSearch,
}: RecentSearchesProps) => {
  return (
    <>
      <Grid.Container spacing="none" align="center">
        <Grid.Item className="hc8-pb-2x" size={{ xs: true }}>
          <strong>Recent searches</strong>
        </Grid.Item>
        {recentSearches.length > 0 ? (
          <>
            {recentSearches?.map((search, index) => {
              return (
                <Grid.Container
                  noWrap
                  key={index}
                  align="center"
                  spacing="none"
                  className="hc8-pr-2x"
                  onMouseEnter={() => setIndex(index)}
                  onMouseLeave={() => setIndex(-1)}
                >
                  <Grid.Item size={{ xs: 9 }}>
                    <ActionArea corners="all">
                      <Card
                        className={`${styles.searchTermCard} hc8-pa-2x ${
                          searchIndex === index ? 'hc8-bg-subdued-active' : ''
                        }`}
                        onClick={() =>
                          handleSelectRecentSearch(search.searchTerm)
                        }
                      >
                        <Icon
                          size="md"
                          svg={TimeHistoryIcon}
                          className="hc8-clr-brand hc8-mr-3x"
                        />
                        <span className={styles.searchTermText}>
                          {getBoldText(search.searchTerm)}
                        </span>
                      </Card>
                    </ActionArea>
                  </Grid.Item>
                  {searchIndex === index && (
                    <Grid.Item
                      align="right"
                      size={{ xs: 3 }}
                      className="hc8-mr-2x"
                    >
                      <Button
                        size="sm"
                        variant="ghost"
                        className="hc8-pv-4x hc8-mr-2x"
                        data-testid={`set-search-to-input-${search.id}`}
                        onClick={() => {
                          setSearchTerm(search.searchTerm)
                          setInputFocus(true)
                        }}
                      >
                        <Icon svg={ArrowUpLeftIcon} />
                      </Button>
                      <Button
                        size="sm"
                        variant="ghost"
                        className="hc8-pv-4x"
                        data-testid={`delete-recent-search-${search.id}`}
                        onClick={() => {
                          handleDeleteRecentSearch(search.id)
                        }}
                      >
                        <Icon svg={CloseIcon} />
                      </Button>
                    </Grid.Item>
                  )}
                </Grid.Container>
              )
            })}
          </>
        ) : (
          <Grid.Container>
            <Grid.Item align="center" size={{ xs: true }}>
              <em>No recent searches</em>
            </Grid.Item>
          </Grid.Container>
        )}
      </Grid.Container>
    </>
  )
}
